<div class="flex flex-col gap-5">
    <div class="card">
        <div class="card-header flex items-center justify-between pb-2">
            <h3>Teams Registered</h3>

            <div>
                <p-datepicker class="m-2" [(ngModel)]="startDate" [showIcon]="true" dateFormat="mm/dd/yy"
                    showButtonBar="true" [showTime]="true" hourFormat="12" (ngModelChange)="getTrips()"></p-datepicker>

                <p-datepicker class="m-2" [(ngModel)]="endDate" [showIcon]="true" dateFormat="mm/dd/yy"
                    showButtonBar="true" [showTime]="true" hourFormat="12" (ngModelChange)="getTrips()"></p-datepicker>

                <button pButton class="p-button-rounded m-2" (click)="getTrips()">Search Trips</button>
            </div>
        </div>
    </div>

    <p-table #dt2 
             dataKey="id"
             [value]="tripDetail()" 
             [columns]="tableColumns()"
             exportFilename="teams-registered"
             sortMode="multiple" 
             [resizableColumns]="true" 
             styleClass="p-datatable-gridlines" 
             [globalFilterFields]="['groupName', 'location', 'glName', 'dateReserved', 'recruiterName', 'attendees', 'attendeesOriginal']"
             [tableStyle]="{'min-width': '50rem'}" [paginator]="true" [rows]="10"
             [rowsPerPageOptions]="[10, 20, 50]" >
        
        <ng-template #caption>
           <app-table-caption [table]="dt2"></app-table-caption>
        </ng-template>

        <ng-template #header>
            <tr>
                <!-- <th pResizableColumn pSortableColumn="groupName">Group Name <p-sortIcon field="groupName" /> <p-columnFilter type="text" field="groupName" display="menu" /></th>
                <th pResizableColumn pSortableColumn="location">Destination <p-sortIcon field="location" /> <p-columnFilter type="text" field="location" display="menu" /></th>
                <th pResizableColumn pSortableColumn="glName">Group Leader <p-sortIcon field="glName" /> <p-columnFilter type="text" field="glName" display="menu" /></th>
                <th pResizableColumn pSortableColumn="id">Trip ID <p-sortIcon field="id" /> <p-columnFilter type="text" field="id" display="menu" /></th>
                <th pResizableColumn pSortableColumn="dateReserved">Date Registered <p-sortIcon field="dateReserved" /> <p-columnFilter type="text" field="dateReserved" display="menu" /></th>
                <th pResizableColumn pSortableColumn="recruiterName">Recruiter <p-sortIcon field="recruiterName" /> <p-columnFilter type="text" field="recruiterName" display="menu" /></th>
                <th pResizableColumn pSortableColumn="attendees">Attendees <p-sortIcon field="attendees" /> <p-columnFilter type="text" field="attendees" display="menu" /></th> -->
                <app-table-headers [columns]="tableColumns()"></app-table-headers>
            </tr>
        </ng-template>

        <ng-template #body let-trips>
            <tr>
                <!-- <td>{{ trips.groupName }}</td>
                <td>{{ trips.location }}</td>
                <td>{{ trips.glName }}</td>
                <td>
                    <button pButton label="{{trips.id}}" class="p-button-rounded"
                        (click)="navigateToContactCard(trips.custId, trips.id)"></button>
                </td>
                <td>{{ trips.dateReserved | date:'shortDate' }}</td>
                <td>{{ trips.recruiterName }}</td>
                <td>{{ trips.attendees }}</td> -->
                <app-table-columns [columns]="tableColumns()" [data]="trips"></app-table-columns>
            </tr>
            
        </ng-template>
    </p-table>
</div>